import { render, staticRenderFns } from "./dropdown-btn.vue?vue&type=template&id=108169c2&scoped=true"
import script from "./dropdown-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdown-btn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108169c2",
  null
  
)

export default component.exports